import { render, staticRenderFns } from "./essay_tab_comments.vue?vue&type=template&id=6d658b22&scoped=true&"
import script from "./essay_tab_comments.vue?vue&type=script&lang=js&"
export * from "./essay_tab_comments.vue?vue&type=script&lang=js&"
import style0 from "./essay_tab_comments.vue?vue&type=style&index=0&id=6d658b22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d658b22",
  null
  
)

export default component.exports